import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PasswordExpiryService {
  private readonly REMIND_LATER_KEY = 'passwordExpiryRemindLater';
  private passwordExpirySubject = new BehaviorSubject<{show: boolean, days: number}>({show: false, days: 0});
  
  passwordExpiry$ = this.passwordExpirySubject.asObservable();

  shouldShowPopup(showPasswordExpiryMessage: boolean): boolean {
    if (!showPasswordExpiryMessage) {
      return false;
    }

    const remindLaterDate = localStorage.getItem(this.REMIND_LATER_KEY);
    if (remindLaterDate) {
      const today = moment();
      const storedDate = moment(remindLaterDate, 'MM-DD-YYYY');
      return today.diff(storedDate, 'days') >= 1;
    }

    return true;
  }

  checkAndTriggerPasswordExpiry(responseData: any): void {
    if (responseData?.showPasswordExpiryMessage && 
        this.shouldShowPopup(responseData.showPasswordExpiryMessage)) {
      this.passwordExpirySubject.next({
        show: true, 
        days: responseData.passwordExpiryDaysRemaining
      });
    }
  }

  setRemindLater(): void {
    const formattedDate = moment().format('MM-DD-YYYY');
    localStorage.setItem(this.REMIND_LATER_KEY, formattedDate);
    this.passwordExpirySubject.next({show: false, days: 0});
  }

  clearRemindLater(): void {
    localStorage.removeItem(this.REMIND_LATER_KEY);
  }

  hidePopup(): void {
    this.passwordExpirySubject.next({show: false, days: 0});
  }
}